<script>
import { formatGetTime } from '@utils/format-date'
import lazyLoadComponent from '@router/lazyload-component'
export default {
  components: {
    BaseUpload: () => lazyLoadComponent(import('@components/BaseUpload')),
    CountryCodePicker: () => lazyLoadComponent(import('@components/CountryCodePicker')),
  },
	props: {
    value: {
      type: Object,
      default: () => {}
    },
    accessType: {
      type: String,
      default: '',
    },
    hasAdminPermission: {
      type: [Array, Boolean],
      default: () => [] || false
    },
    defaultValue: {
      type: Object,
      default: () => {},
    },
	},
  data() {
    return {
      endDatePickerOptions: {
        disabledDate: (time) => {
          // check String or Date Object
          const selectedStartDate = this.value.takeOfficeDate instanceof Object ? this.value.takeOfficeDate : new Date(this.value.takeOfficeDate)
          return time < selectedStartDate
          // 下面是限定一年以後不給點選，先拔掉
          // const limitWith365Days = selectedStartDate.getTime() + 3600 * 1000 * 24 * 365
          // return time < selectedStartDate || time.getTime() >= limitWith365Days
        },
      },
      checkedPwd: false, // 確認變更密碼
      showCheckBox: false, // 看要不要顯示變更密碼按鈕
      repasswordVisible: false,
      passwordVisible: false,
    }
  },
  computed: {
    submitData: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value);
      }
    },
    isEditMode() {
      return this.defaultValue.id
    },
    submitRules() {
      const isTaiwan = this.value.phoneCode === '+886'
      return {
        // avatar: [
        //   {
        //     required: true,
        //     message: '請上傳頭像',
        //     // trigger: 'change',
        //   },
        // ],
        // name: [
        //   {
        //     required: true,
        //     message: '請填寫姓名',
        //     trigger: 'blur',
        //   },
        // ],
        account: [
          { required: true, message: '請輸入 Email', trigger: 'blur' },
          { type: 'email', message: '請輸入正確的 Email 格式', trigger: 'blur' },
        ],
        secretCode: [
          {
            required: !this.isEditMode,
            message: '請輸入密碼',
            trigger: 'blur',
          },
          {
            validator: (rule, value, callback) => {
              const passwordPattern = /^\S{8,16}$/
              if (!passwordPattern.test(value)) {
                callback(new Error('請使用 8~16 個大小寫英文字母、數字與特殊符號組合'))
              }
              if (this.value.secretCodeConfirm !== '') {
                this.$refs.form.validateField('secretCodeConfirm')
              }
              callback()
            },
            trigger: 'blur',
          },
        ],
        secretCodeConfirm: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (!value) return callback(new Error('請再次輸入密碼'))
              const passwordValue = this.submitData.secretCode
              if (value !== passwordValue) {
                callback(new Error('兩次輸入的密碼不一致'))
              }
              callback()
            },
            trigger: 'blur',
          },
        ],
        // title: [
        //   {
        //     required: true,
        //     message: '請填寫職位',
        //     trigger: 'blur',
        //   },
        // ],
        // phoneCode: [
        //   {
        //     required: true,
        //     message: '請選擇電話國碼',
        //     trigger: 'change',
        //   },
        // ],
        // phoneNumber: [
        //   {
        //     required: true,
        //     message: '請填寫聯絡電話',
        //     trigger: 'blur',
        //   },
        //   {
        //     pattern: isTaiwan ? /^02\d{7,8}$|^09\d{8}$/ : '',
        //     message: '市話號碼格式請符合 02XXXXXXXX；手機號碼格式請符合 09XXXXXXXX',
        //     trigger: 'blur',
        //   },
        // ],
        // takeOfficeDate: [
        //   {
        //     validator: (rule, value, callback) => {
        //       if (this.submitData.takeOfficeDate) this.$refs.form.validateField('leaveOfficeDate')
        //       callback()
        //     },
        //     trigger: 'change',

        //   },
        // ],
        // leaveOfficeDate: [
        //   {
        //     validator: (rule, value, callback) => {
        //       if (this.submitData.takeOfficeDate && !!value) {
        //         const isSmallThanTakeOfficeDate = formatGetTime(this.submitData.takeOfficeDate) > formatGetTime(value)
        //         if (isSmallThanTakeOfficeDate) return callback(new Error('不得小於到職日期'))
        //       }
        //       callback()
        //     },
        //     trigger: 'change',
        //   },
        // ],
        // userGroupIds: [
        //   {
        //     required: true,
        //     message: '請選擇權限',
        //     // trigger: 'blur',
        //   },
        // ],
        // userGroupStoreIds: [
        //   {
        //     required: true,
        //     message: '請選擇負責分店',
        //     trigger: 'change',
        //   },
        // ],
      }
    },
  },
  mounted() {
    this.showPwdCheck()
  },
  methods: {
    showPwdCheck() {
      // 完全新增
      if (!this.value.id) {
        this.showCheckBox = false
        this.checkedPwd = true
        return
      }
      // 從角色列表新增
      if (!this.defaultValue.id && this.value.id) {
        this.showCheckBox = true
        this.checkedPwd = false
        return
      }
      // 等同編輯角色
      if (this.defaultValue.id.length > 0 && this.value.id) {
        this.showCheckBox = true
        
      }
    },
  }
}
</script>

<template>
  <div :class="$style.pageContent">
    <el-form ref="form" :model="submitData" :rules="submitRules" label-position="top" class="el-form--floating"
      :class="$style.allPageStyle" :validate-on-rule-change="false">
      <el-row>
        <el-col :md="24">
          <el-form-item v-if="accessType !== 'employee'" label="Email" prop="account">
            <el-input v-model="submitData.account" :autocomplete="isEditMode > 0 ? 'on' : 'off'" />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-checkbox v-if="showCheckBox" v-model="checkedPwd">變更密碼</el-checkbox>
      </el-row>
      <el-row>
        <el-col :md="24">
          <!-- accountId === 0 && passwordEditable -->
          <el-form-item v-if="checkedPwd" label="密碼" prop="secretCode">
            <el-input v-model="submitData.secretCode" :type="passwordVisible ? 'text' : 'password'"
              :autocomplete="isEditMode ? 'on' : 'off'">
              <template v-slot:append>
                <div style="cursor: pointer;" @click="passwordVisible = !passwordVisible">
                  <BaseIcon :name="!passwordVisible ? 'eye' : 'eye-slash'" />
                </div>
              </template>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :md="24">
          <el-form-item v-if="checkedPwd" label="確認密碼" prop="secretCodeConfirm">
            <el-input v-model="submitData.secretCodeConfirm" :type="repasswordVisible ? 'text' : 'password'"
              :autocomplete="isEditMode ? 'on' : 'off'">
              <template v-slot:append>
                <div style="cursor: pointer;" @click="repasswordVisible = !repasswordVisible">
                  <BaseIcon :name="!repasswordVisible ? 'eye' : 'eye-slash'" />
                </div>
              </template>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <!-- accountId === 0 && passwordEditable -->
    </el-form>
  </div>
</template>

<style lang="scss" module>
@import '@src/design/layout_detail_steps.scss';
.pageContent {
  padding-bottom: 5rem;
  background-color: white;
}
.pageBaseInfo {
  // background-color: white;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  // padding: 20px;
  :global {
    .basicInfoForMainPart {
      padding-left: 20px;
    }

    .imgPlacement {
      display: flex;
      justify-content: center;
    }
  }
}

.isEmployeeMob {
  margin-top: 24px;

  @include max-md {
    margin-top: 100px;
  }

  @include max-lg {
    margin-top: 100px;
  }

  @include max-sm {
    margin-top: 100px;
  }
}
</style>